export const getTemas = (state) => state.temas.lista
export const getIsSavingTemas = (state) => state.temas.isSaving
export const getIsCarregandoListaTemas = (state) => state.temas.isCarregandoLista
